"use client";

import React, { createContext, useState, useMemo } from "react";

const AppStateContext = createContext();

const AppStateProvider = ({ children }) => {
  const [videoOpen, setVideoOpen] = useState(false)
  const [userProfile, setUserProfile] = useState(null);
  // NOTE: orgDetails state removed in Phase 3E — onboarding flow killed.
  // We still expose `orgDetails: null` + `setOrgDetails: noop` below so any
  // lingering consumer that destructures them keeps compiling. Delete in
  // Phase 5 once create-interview / interviews pages stop destructuring.
  const [retellVoices, setRetellVoices] = useState([]);
  const [isUserFetching, setIsUserFetching] = useState(true);
  const [options, setOptions] = useState([]);
  const [finalInterviews, setFinalInterviews] = useState([]);
  // Determine if the user is on a free plan
  const isFreePlan = userProfile?.plan?.id === 1;

  // Total and used seconds
  const totalSeconds = isFreePlan
    ? userProfile?.plan?.free_seconds || 0
    : userProfile?.plan?.prices?.total_seconds || 0;

  const usedSeconds = isFreePlan
    ? userProfile?.free_seconds_used_today || 0
    : userProfile?.seconds_used || 0;

  const mainUsedSeconds = userProfile?.seconds_used || 0

  // Round UP to the nearest minute
  const totalMinutes = Math.ceil(totalSeconds / 60);
  const usedMinutes = Math.ceil(usedSeconds / 60);

  const mainUsedMinutes = Math.ceil(mainUsedSeconds / 60);

  // ✅ Memoize the entire context value to avoid re-renders
  const contextValue = useMemo(
    () => ({
      userProfile,
      setUserProfile,
      isUserFetching,
      setIsUserFetching,
      retellVoices,
      setRetellVoices,
      options,
      setOptions,
      finalInterviews,
      setFinalInterviews,
      totalMinutes,
      usedMinutes, mainUsedMinutes,
      totalSeconds,
      usedSeconds,
      isFreePlan,
      orgDetails: null,
      setOrgDetails: () => {},
      videoOpen,
      setVideoOpen,
    }),
    [
      userProfile,
      isUserFetching,
      retellVoices,
      options,
      finalInterviews,
      totalMinutes,
      usedMinutes, mainUsedMinutes,
      totalSeconds,
      usedSeconds,
      isFreePlan,
      videoOpen,
    ]
  );

  return (
    <AppStateContext.Provider value={contextValue}>
      {children}
    </AppStateContext.Provider>
  );
};

export { AppStateContext, AppStateProvider };
